import {
  base_colorContentBorder,
  grey100,
  text_colorTextPrimary,
  text_colorTextSecondary,
  white100,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import {
  font_family_weight_medium,
  font_sm,
  font_xs,
} from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  &.InterruptCard {
    margin-bottom: ${spacing(4)};
    padding: ${spacing(4)};
    background-color: ${grey100};
    border-radius: 8px;
    border: 1px solid ${base_colorContentBorder};

    .interrupt-header {
      display: flex;
      align-items: center;
      gap: ${spacing(2)};
      margin-bottom: ${spacing(3)};

      .tool-name {
        ${font_sm};
        font-family: ${font_family_weight_medium};
        color: ${text_colorTextPrimary};
      }
    }

    .interrupt-message {
      ${font_sm};
      color: ${text_colorTextPrimary};
      margin-bottom: ${spacing(3)};
    }

    .tool-inputs {
      margin-bottom: ${spacing(3)};
      padding: ${spacing(3)};
      background-color: ${white100};
      border-radius: 6px;
      border: 1px solid ${base_colorContentBorder};

      .inputs-label {
        ${font_xs};
        font-family: ${font_family_weight_medium};
        color: ${text_colorTextSecondary};
        margin-bottom: ${spacing(2)};
      }

      .inputs-content {
        ${font_xs};
        font-family: monospace;
        white-space: pre-wrap;
        word-break: break-word;
        color: ${text_colorTextPrimary};
      }
    }

    .actions-wrapper {
      display: flex;
      gap: ${spacing(2)};
      flex-wrap: wrap;

      .action-button {
        flex: 1;
        min-width: 100px;
      }
    }

    .feedback-form {
      margin-top: ${spacing(3)};
      padding: ${spacing(3)};
      background-color: ${white100};
      border-radius: 6px;
      border: 1px solid ${base_colorContentBorder};

      .feedback-actions {
        display: flex;
        gap: ${spacing(2)};
        margin-top: ${spacing(2)};
        justify-content: flex-end;
      }
    }

    .feedback-display {
      margin-top: ${spacing(3)};
      ${font_sm};
      color: ${text_colorTextSecondary};

      .edit-button {
        margin-left: ${spacing(2)};
        padding: 0;
        height: auto;
      }
    }
  }
`
